<template>
  <!-- 单位信息 -->
  <div class="person-info">
    <h3>
      <i></i>
      <span>单位信息</span>
      <div class="edit" @click="editInfo" v-if="!onEdit && hasFinished"><img src="../../assets/edit_icon.png"> 编辑</div>
    </h3>
    <div class="person-box">
      <section class="checkbox-sec">
        <label class="tit">管理区域：</label>
        <div class="con">
          <el-select v-model="areas" placeholder="请选择" v-if="!hasFinished || onEdit" @change="getArea">
            <el-option v-for="(area, key) in institutionInfo.dicManageAreas" :key="key" :label="area" :value="key"></el-option>
          </el-select>
          <div class="txt" v-if="!onEdit && hasFinished">{{areasName}}</div>
        </div>
        <span class="error" v-if="gradeErr">请选择管理区域</span>
      </section>
      <section class="checkbox-sec">
        <label class="tit">机构类型：</label>
        <div class="con">
          <el-select v-model="agencys" placeholder="请选择" v-if="!hasFinished || onEdit" @change="getAgency">
            <el-option v-for="(agency, key) in institutionInfo.dicInsTypes" :key="key" :label="agency" :value="key"></el-option>
          </el-select>
          <div class="txt" v-if="!onEdit && hasFinished">{{agencysName}}</div>
        </div>
        <span class="error" v-if="classErr">请选择机构类型</span>
      </section>
      <section class="school-sec" v-if="!isManagement">
        <label class="tit">学校名称：</label>
        <div class="con school-con">
          <el-select v-model="schoolarea" placeholder="请选择" v-if="!hasFinished || onEdit"  @change="getRegion">
            <el-option v-for="(sarea, key) in institutionInfo.dicDistincts" :key="key" :label="sarea" :value="key"></el-option>
          </el-select>
          <el-select v-model="school" placeholder="可输入学校名称搜索" filterable v-if="!hasFinished || onEdit" @change="getSchool">
            <el-option v-for="sitem in schoolsOptions" :key="sitem.schoolId" :label="sitem.schoolName" :value="sitem.schoolId"></el-option>
          </el-select>
          <div class="no-school" @click="noSchool" v-if="!hasFinished || onEdit">未找到学校？</div>
          <div class="txt" v-if="!onEdit && hasFinished">{{school}}</div>
        </div>
        <span class="error" v-if="schoolErr">请填写学校名称</span>
      </section>
      <section class="checkbox-sec speciality-sec" v-if="!isManagement">
        <label class="tit">是否外语类学校：</label>
        <div class="con">
          <el-radio-group v-model="isForeign" v-if="!hasFinished || onEdit">
            <el-radio label="是"></el-radio>
            <el-radio label="否"></el-radio>
          </el-radio-group>
          <div class="txt" v-if="!onEdit && hasFinished ">{{isForeign}}</div>
        </div>
        <span class="error" v-if="isForeignErr">请选择是否外语类学校</span>
      </section>
      <section class="btn" v-if="!hasFinished || onEdit">
        <label class="tit">&nbsp;</label>
        <div class="con">
          <el-button type="primary" @click="onSubmit">保存</el-button>
        </div>
      </section>
    </div>
    <!-- 联系客服 -->
    <HelpDialog ref="HelpDialog"></HelpDialog>
  </div>
</template>
<script>
import api from '../../utils/api'
import HelpDialog from './help'
export default {
  props: ['institutionInfo'],
  components: {
    HelpDialog
  },
  data () {
    return {
      hasFinished: this.institutionInfo.finishStatus, // 是否已经完成编辑
      areas: '',
      areasName: this.institutionInfo.manageAreaName,
      manageArea: 0,
      agencys: '',
      agencysName: this.institutionInfo.belongTypeName,
      belongType: 0,
      school: '',
      schoolId: 0,
      schoolarea: '',
      areaCode: 0,
      areaName: '',
      areaList: this.institutionInfo.dicDistincts, // 区列表
      schoolsOptions: '',
      isForeign: '', // 是否外语学校
      isManagement: false, // 是否是管理部门
      // 错误提示
      gradeErr: false,
      classErr: false,
      schoolErr: false,
      isForeignErr: false,
      // 编辑
      onEdit: false
    }
  },
  mounted () {
    this.setDataInit()
    this.userId = window.sessionStorage.getItem('userId')
  },
  methods: {
    // 数据初始化
    setDataInit () {
      // 未提交信息
      let institutionInfoLocal = window.sessionStorage.getItem('loaclInstitutionInfo')
      if (institutionInfoLocal) {
        let info = JSON.parse(institutionInfoLocal)
        this.hasFinished = info.finishStatus
        this.areas = info.manageAreaName
        this.agencys = info.belongTypeName
        this.areasName = info.manageAreaName
        this.agencysName = info.belongTypeName
        this.manageArea = info.manageArea
        this.belongType = info.belongType
        if (!info.isManagement) {
          this.school = info.schoolName
          this.isForeign = info.isForeignSchool ? '是' : '否'
          this.areaCode = info.areaCode
          this.setRegion((this.areaCode).toString())
          for (let i in this.institutionInfo.dicDistincts) {
            if (Number(i) === info.areaCode) {
              this.schoolarea = this.institutionInfo.dicDistincts[i]
            }
          }
        } else {
          this.isManagement = true
        }
      } else if (this.institutionInfo.manageAreaName !== '') {
        this.areas = this.institutionInfo.manageAreaName
        this.agencys = this.institutionInfo.belongTypeName
        this.areasName = this.institutionInfo.manageAreaName
        this.agencysName = this.institutionInfo.belongTypeName
        this.manageArea = this.institutionInfo.manageArea
        this.belongType = this.institutionInfo.belongType
        if (this.belongType !== 1 && this.belongType !== 2 && this.belongType !== 3) {
          for (let i in this.institutionInfo.dicDistincts) {
            if (i === this.institutionInfo.areaCode) {
              this.schoolarea = this.institutionInfo.dicDistincts[i]
              // console.log(this.schoolarea)
            }
          }
          this.areaCode = this.institutionInfo.areaCode
          this.school = this.institutionInfo.schoolName
          this.isForeign = this.institutionInfo.isForeignSchool ? '是' : '否'
          this.setRegion((this.areaCode).toString())
        } else {
          this.isManagement = true
        }
      }
    },
    // 管理区域
    getArea (val) {
      for (let i in this.institutionInfo.dicManageAreas) {
        if (val === i) {
          this.areasName = this.institutionInfo.dicManageAreas[i]
          this.manageArea = Number(val)
        }
      }
      this.gradeErr = false
    },
    // 机构类型
    getAgency (val) {
      this.classErr = false
      // 管理部门
      if (val === '1' || val === '2' || val === '3') {
        this.isManagement = true
      } else {
        this.isManagement = false
      }
      this.$emit('isManagement', this.isManagement)
      for (let i in this.institutionInfo.dicInsTypes) {
        if (val === i) {
          this.agencysName = this.institutionInfo.dicInsTypes[i]
          this.belongType = Number(val)
        }
      }
    },
    // 选择区 获取学校列表
    setRegion (val) {
      let areaStr = ''
      let _this = this
      for (let i in _this.areaList) {
        if (val === i) {
          areaStr = '广东省-深圳市-' + _this.areaList[i]
          _this.areaName = _this.areaList[i]
        }
      }
      // 获取学校列表
      api.post('GetSchoolListByAreaRequest', {
        area: areaStr
      }, res => {
        // console.log(res)
        _this.schoolsOptions = res.body.schools
      })
    },
    getRegion (val) {
      let areaStr = ''
      let _this = this
      this.school = ''
      this.areaCode = Number(val)
      for (let i in _this.areaList) {
        if (val === i) {
          areaStr = '广东省-深圳市-' + _this.areaList[i]
          _this.areaName = _this.areaList[i]
        }
      }
      // 获取学校列表
      api.post('GetSchoolListByAreaRequest', {
        area: areaStr
      }, res => {
        // console.log(res)
        _this.schoolsOptions = res.body.schools
      })
    },
    getSchool (val) {
      for (let i = 0; i < this.schoolsOptions.length; i++) {
        if (val === this.schoolsOptions[i].schoolId) {
          this.school = this.schoolsOptions[i].schoolName
        }
      }
      this.schoolId = val
      this.schoolErr = false
    },
    // 未找到学校
    noSchool () {
      this.$refs.HelpDialog.showDialog()
    },
    // 提交
    onSubmit () {
      let _this = this
      let institutionInfoData
      if (_this.areas === '') {
        _this.gradeErr = true
        return false
      }
      if (_this.agencys === '') {
        _this.classErr = true
        return false
      }
      if (!_this.isManagement) {
        if (_this.school === '') {
          _this.schoolErr = true
          return false
        }
        if (_this.isForeign === '') {
          _this.isForeignErr = true
          return false
        }
        institutionInfoData = {
          userId: _this.userId,
          manageArea: _this.manageArea,
          belongType: _this.belongType,
          areaCode: _this.areaCode,
          schoolName: _this.school,
          schoolId: _this.schoolId,
          isForeignSchool: _this.isForeign === '是',
          finishStatus: false
        }
      } else {
        institutionInfoData = {
          userId: _this.userId,
          manageArea: _this.manageArea,
          belongType: _this.belongType,
          finishStatus: false
        }
      }
      let loaclInstitutionInfo
      if (!_this.isManagement) {
        loaclInstitutionInfo = {
          isManagement: false,
          manageAreaName: _this.areasName,
          manageArea: _this.manageArea,
          belongTypeName: _this.agencysName,
          belongType: _this.belongType,
          areaCode: _this.areaCode,
          areaName: _this.areaName,
          schoolName: _this.school,
          schoolId: _this.schoolId,
          isForeignSchool: _this.isForeign === '是',
          finishStatus: true
        }
      } else {
        loaclInstitutionInfo = {
          isManagement: true,
          manageAreaName: _this.areasName,
          manageArea: _this.manageArea,
          belongTypeName: _this.agencysName,
          belongType: _this.belongType,
          finishStatus: true
        }
      }
      api.post('SaveSZTeacherPersonalInfoRequest', {
        part: 3,
        institutionInfo: institutionInfoData
      }, res => {
        // console.log(res)
        _this.$message({
          message: '单位信息保存成功',
          type: 'success'
        })
        window.sessionStorage.setItem('loaclInstitutionInfo', JSON.stringify(loaclInstitutionInfo))
        _this.hasFinished = true
        if (!_this.onEdit) {
          _this.$emit('hasFinish', 2)
        } else {
          _this.onEdit = false
        }
      })
    },
    // 编辑
    editInfo () {
      this.onEdit = true
      this.areas = this.areasName
      this.agencys = this.agencysName
      this.schoolarea = this.schoolarea
      this.school = this.school
      this.schoolId = this.schoolId
      this.isForeign = this.isForeign
    }
  }
}
</script>
<style scoped>
  .person-info h3 {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: normal;
  }
  .person-info h3 i {
    width: 2px;
    height: 16px;
    background: #FE793A;
    margin-right: 10px;
  }

  .person-info h3 span {
    flex: 1;
  }

  .person-info h3 .edit {
    color: #FE793A;
    font-size: 12px;
    cursor: pointer;
  }

  .person-info h3 .edit img {
    width: 12px;
    height: 12px;
    vertical-align: middle;
    margin-bottom: 3px;
  }

  .person-box {
    margin-top: 24px;
  }
  .person-box section {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .person-box section .tit {
    width: 70px;
    font-size: 14px;
    color: #333;
  }

  .person-box section.speciality-sec .tit {
    width: 120px;
  }

  .person-box section .con {
    width: 230px;
    margin-left: 5px;
  }
  .person-box section .txt {
    font-size: 14px;
  }
  .person-box section .error {
    width: 345px;
    text-align: left;
    font-size: 12px;
    color: #ff0000;
  }

  .person-box section.checkbox-sec .con .el-checkbox-group {
    display: inline;
  }
  .person-box section.checkbox-sec .error {
    width: 160px;
  }
  .person-box section.checkbox-sec .el-checkbox {
    margin-bottom: 10px;
  }
  .person-box section.speciality-sec .con {
    width: 420px;
  }
  .person-box section.speciality-sec .error {
    width: 120px;
  }
  .person-box section.speciality-sec .el-checkbox {
    margin-bottom: 0;
  }
  .person-box section.btn {
    margin-top: 40px;
  }
  .person-box section .con.school-con {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 420px;
  }
  .person-box section .con.school-con .el-select {
    width: 200px;
  }
  .person-box section .con.school-con .el-select:first-child {
    width: 100px;
  }
  .person-box section.school-sec .error {
    width: 100px;
  }
  .no-school {
    width: 80px;
    font-size: 12px;
    color: #aaa;
    cursor: pointer;
  }
  .w35 {
    width: 35.5%;
  }
</style>
